import type { BootFallbackGridSpec } from "@slot/game-shell";

/**
 * The board before the first round and after a recovery: 6×6, every symbol of the ladder but the scatter, no cluster
 * of four (a dead board, so it reads as a board at rest). Rows split on '|', cells on ',' — the platform's
 * `DelimitedGridCodec`, which throws at the boot paint if this is not 6×6.
 */
export const BOOT_FALLBACK_GRID: BootFallbackGridSpec = {
  encodedGridSnapshot:
    "L1,L3,L2,H2,L4,H1|" +
    "L2,H1,L4,L1,H3,L2|" +
    "L4,L1,H2,L3,L1,H4|" +
    "H3,L2,L3,H1,L2,L3|" +
    "L1,H4,L1,L4,H2,L1|" +
    "L3,L2,H1,L2,L3,L4",
  reelSetIdentifier: "default",
};
